import rocketImage from 'assets/rocket.svg';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { breakpoint } from 'app/theme/theme';
import { needItSooner } from 'app/translations/dictionary/needItSooner';
import { DialogWithImage } from 'pkg/components/DialogWithImage';
import { useTitle } from 'pkg/titleHooks/useTitle';

import { NeedItSoonerForm } from './NeedItSoonerForm';

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.4rem;
  text-align: center;
  margin: 0;
  ${breakpoint.up.sm`
    text-align: left;
  `}
  ${breakpoint.up.md`
    font-size: 4rem;    
    line-height: 5.4rem;
  `}
`;

const InformationText = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.9rem;
  text-align: center;
  margin: 0.5rem 0;
  ${breakpoint.up.sm`
    text-align: left;
  `}
  ${breakpoint.up.md`
    font-size: 1.8rem;
    line-height: 2.5rem;    
    margin: 0.5rem 0;
  `}
`;

const DialogContent = styled.div`
  max-width: 40rem;
  ${breakpoint.up.sm`
    max-width: 100%;
    width: 100%;
    margin-left: 6rem;
    margin-right: 3.5rem;
  `}
  ${breakpoint.up.md`
    margin-right: 7rem;
  `}
`;

const Image = styled.img`
  width: 19rem;
  height: 16.8rem;
  margin-top: -2.5rem;
  margin-bottom: 1.5rem;
  ${breakpoint.up.sm`
    width: 56rem;
    height: 45rem;
    margin: 0;
  `}
  ${breakpoint.up.md`
    height: 50rem;
    margin-top: 0;
    margin-left: 4.5rem;
  `}
`;

export const NeedItSooner = (): JSX.Element => {
  useTitle(needItSooner.dialogTitle);
  const history = useHistory();

  return (
    <DialogWithImage onClose={history.goBack} image={<Image src={rocketImage} alt={needItSooner.altImg} />}>
      <DialogContent>
        <Title>{needItSooner.dialogTitle}</Title>
        <InformationText>{needItSooner.information}</InformationText>
        <NeedItSoonerForm />
      </DialogContent>
    </DialogWithImage>
  );
};
